module.exports = __webpack_public_path__ + "static/team_c-0c895e3726990c915e1c1692c04ccca3.webp";